/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EnergyConsumption
 */
export interface EnergyConsumption {
    /**
     * for debugging
     * @type {Date}
     * @memberof EnergyConsumption
     */
    cursor?: Date;
    /**
     * for debugging. The raw db row timestamp.
     * @type {Date}
     * @memberof EnergyConsumption
     */
    rowValueUtc?: Date;
    /**
     * The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00`
     * @type {Date}
     * @memberof EnergyConsumption
     */
    timestamp?: Date;
    /**
     * Date label, to avoid timezone conversions in frontend. eg:
     * Hour: yyyy-MM-ddTHH:00:00
     * Day: yyyy-MM-dd
     * Week: 2022W01 (week-of-year, new weeks start on Sunday)
     * Month: 2022M01
     * @type {string}
     * @memberof EnergyConsumption
     */
    label?: string;
    /**
     * Energy in Wh
     * @type {number}
     * @memberof EnergyConsumption
     */
    energy?: number;
}

/**
 * Check if a given object implements the EnergyConsumption interface.
 */
export function instanceOfEnergyConsumption(
    value: object,
): value is EnergyConsumption {
    return true;
}

export function EnergyConsumptionFromJSON(json: any): EnergyConsumption {
    return EnergyConsumptionFromJSONTyped(json, false);
}

export function EnergyConsumptionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EnergyConsumption {
    if (json == null) {
        return json;
    }
    return {
        cursor: json["cursor"] == null ? undefined : new Date(json["cursor"]),
        rowValueUtc:
            json["rowValueUtc"] == null
                ? undefined
                : new Date(json["rowValueUtc"]),
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        label: json["label"] == null ? undefined : json["label"],
        energy: json["energy"] == null ? undefined : json["energy"],
    };
}

export function EnergyConsumptionToJSON(value?: EnergyConsumption | null): any {
    if (value == null) {
        return value;
    }
    return {
        cursor:
            value["cursor"] == null ? undefined : value["cursor"].toISOString(),
        rowValueUtc:
            value["rowValueUtc"] == null
                ? undefined
                : value["rowValueUtc"].toISOString(),
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        label: value["label"],
        energy: value["energy"],
    };
}
